import type * as ReactPDFTypes from "@react-pdf/renderer";

type PdfModule = typeof ReactPDFTypes;

let mod_PdfLib: PdfModule | null = null;
let _loadPromise: Promise<void> | null = null;

export async function loadReactPdf() {
    if (mod_PdfLib) return;
    if (_loadPromise) return _loadPromise;
    _loadPromise = (import("@react-pdf/renderer") as unknown as Promise<PdfModule>).then((m) => {
        mod_PdfLib = m;
    });
    return _loadPromise;
}


// Direkter Zugriff auf das PDF-Modul
// WICHTIG: Nur verwenden nachdem loadReactPdf() aufgerufen wurde!
// loadReactPdf wir zur ZEIT NUR in LazyPdfListViewer in WorkingPanes.tsx aufgerufen.
//

export function getPdfRenderer() {
    if (!mod_PdfLib) {
        console.error("getPdfRenderer: PDF Renderer not loaded yet. Make sure loadReactPdf() has been called.");
    }

    return mod_PdfLib;
}
